import { createReduxEnhancer } from '@sentry/react';

import type { StoreModel } from '~/store/model';

type StoreAction = { type: string; payload: unknown & { id?: string } };

const REACTED_STRING_PLACEHOLDER = 'REDACTED_ON_CLIENT';

/**
 * Redux Store (as used by easy-peasy) Enhancer to remove sensitive data before sending the data to Sentry.
 Currently returns the action and state as is without any transformation.
 */
export const sentryReduxEnhancer = createReduxEnhancer({
    actionTransformer: (action: StoreAction) => {
        if (action.payload?.id) {
            const sensitiveIds = ['api/users'];
            const regex = new RegExp(`(${sensitiveIds.join('|')})`);
            if (regex.test(action.payload?.id)) {
                return {
                    ...action,
                    payload: {
                        ...action.payload,
                        id: REACTED_STRING_PLACEHOLDER,
                    },
                };
            }
        }

        return action;
    },
    stateTransformer: (state: StoreModel) => {
        return state;
    },
});
